/**
 * Social sharing functionality
 * @module social
 */

export function initializeSocialSharingDropdownActions() {
  const dropdowns = document.querySelectorAll('.wp-block-kbs-post-meta-bar__social-dropdown');
  let activeDropdown = null;

  dropdowns.forEach((dropdown) => {
    const trigger = dropdown.querySelector('.wp-block-kbs-post-meta-bar__social-dropdown-trigger');
    const menu = dropdown.querySelector('.wp-block-kbs-post-meta-bar__social-dropdown-items');

    if (!trigger || !menu) return;

    menu.classList.add('has-trigger');

    // Function to calculate and update menu position
    const updateMenuPosition = () => {
      if (!menu.isConnected) return;

      const triggerRect = trigger.getBoundingClientRect();
      const menuWidth = Math.min(menu.offsetWidth, 236);
      const menuHeight = menu.offsetHeight;

      if (window.innerWidth < 768) {
        menu.style.position = 'fixed';
        menu.style.bottom = '74px';
        menu.style.left = '16px';
        menu.style.right = '16px';
        menu.style.width = 'auto';
        menu.style.maxWidth = '100%';
        menu.style.top = 'auto';
      } else {
        const spaceBelow = window.innerHeight - triggerRect.bottom;
        const spaceAbove = triggerRect.top;

        const top = spaceBelow < menuHeight && spaceAbove > menuHeight
            ? triggerRect.top + window.scrollY - menuHeight - 8
            : triggerRect.bottom + window.scrollY + 8;

        let left = triggerRect.left + window.scrollX + ( triggerRect.width / 2 ) - ( menuWidth / 2 );
        left = Math.max(16, Math.min(left, window.innerWidth - menuWidth - 16));

        menu.style.position = 'absolute';
        menu.style.top = `${top}px`;
        menu.style.left = `${left}px`;
        menu.style.width = `${menuWidth}px`;
        menu.style.bottom = 'auto';
        menu.style.right = 'auto';
      }

      menu.style.zIndex = '9999';
    };

    const closeDropdown = (currentDropdown) => {
      if (!currentDropdown) return;

      currentDropdown.setAttribute('aria-expanded', 'false');
      if (menu.style.display === 'block') {
        menu.style.display = 'none';
      }

      if (menu.parentNode === document.body) {
        currentDropdown.appendChild(menu);
      }

      activeDropdown = null;
    };

    const openDropdown = (newDropdown) => {
      if (activeDropdown && activeDropdown !== newDropdown) {
        closeDropdown(activeDropdown);
      }

      newDropdown.setAttribute('aria-expanded', 'true');
      document.body.appendChild(menu);
      menu.style.display = 'block';
      updateMenuPosition();
      activeDropdown = newDropdown;
    };

    // Event Listeners
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const isExpanded = dropdown.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        closeDropdown(dropdown);
      } else {
        openDropdown(dropdown);
      }
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (event) => {
      // Ignore clicks on navmenu elements
      if (event.target.closest('.wp-block-navigation')) return;

      // Only handle clicks outside the dropdown
      if (!event.target.closest('.wp-block-kbs-post-meta-bar__social-dropdown')) {
        closeDropdown(activeDropdown);
      }
    });

    // Update position on resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (activeDropdown) {
          updateMenuPosition();
        }
      }, 100);
    });

    // Clean up on page unload
    window.addEventListener('unload', () => {
      closeDropdown(activeDropdown);
    });
  });
}

initializeSocialSharingDropdownActions();
